import { AbstractResource } from '../../AbstractResource'

class ClassObjectivesQueryResource extends AbstractResource {
  constructor() {
    super()
    this._endpointUrl = '/api/internal/alignments/class_objectives'
  }
}

export { ClassObjectivesQueryResource }